import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import {
	fetchLogicsConfiguration,
	selectCommitRefs,
	selectFetchLanguagesStatus,
	selectFetchLogicsStatus,
} from "../../../logics/logicsSlice";
import css from "./LogicsSelector.module.css";

export function LogicsSelector() {
	const { t } = useTranslation();
	const dispatch = useAppDispatch();
	const commitRefs = useAppSelector(selectCommitRefs);
	const logicsStatus = useAppSelector(selectFetchLogicsStatus);
	const languagesStatus = useAppSelector(selectFetchLanguagesStatus);
	const isDevModeActive = useAppSelector((state) => state.system.devMode);
	const [selectedCommitIndex, setSelectedCommitIndex] = useState<number>(0);

	return (
		<div className={css.logicsSelector}>
			{logicsStatus.code !== "loading" && (
				<div className={css.selectorWrapper}>
					<div className={css.selectorInfo}>{t("startMessage")}</div>
					<select
						id="select-commits"
						className={css.selectorSelect}
						value={selectedCommitIndex}
						onChange={(event) =>
							setSelectedCommitIndex(Number(event.target.value))
						}
					>
						{commitRefs
							.map((ref, index) => (
								<option key={`${ref.hash}-${ref.name}`} value={index}>
									{ref.name.startsWith("JSON_")
										? `Firmware ${ref.name.slice(5)}`
										: ref.name}{" "}
									{ref.datasetVersion && ` / Dataset V${ref.datasetVersion}`}
								</option>
							))
							.filter((_, index) => {
								return true;
								if (isDevModeActive) {
									return true;
								}
								return commitRefs[index].name.startsWith("JSON_");
							})}
					</select>
				</div>
			)}
			{logicsStatus.code === "loading" && (
				<div className={css.selectorWrapper}>
					<div className={css.selectorInfo}>
						{t("languageCommit", { commit: logicsStatus.commit.name })}
					</div>
				</div>
			)}
			{languagesStatus.code === "loading" && (
				<div className={css.selectorWrapper}>
					<div className={css.selectorInfo}>{t("languageLoading")}</div>
				</div>
			)}
			{logicsStatus.code !== "loading" && (
				<button
					name="Load"
					className={css.selectorButton}
					onClick={() => {
						const commit = commitRefs[selectedCommitIndex];

						dispatch(
							fetchLogicsConfiguration({
								...commit,
								migrate: false,
							}),
						);
					}}
				>
					{t("Load")}
				</button>
			)}
		</div>
	);
}
